import React from "react";
import {
  Layout,
  Col,
  Row,
  Button,
  Form,
  Input,
  Checkbox,
  Image
} from "antd";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { Post } from "../../config/api/post";
import { USER_AUTH } from "../../config/constants/api";
import { addUser } from "../../redux/slice/authSlice";
import Logo from "../../assets/luxurycarlogo.png";
import facebook from "../../assets/authfb.png";
import twitter from "../../assets/twitter.png";
import google from "../../assets/google.png";
import socket from "../../config/socket";

import swal from "sweetalert";
import { Link } from "react-router-dom";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const user = useSelector((state) => state.user.userData);
  // const token = useSelector((state) => state.user.userToken);
  const [loading, setLoading] = React.useState(false);

  // React.useEffect(() => {
  //   if (user && token) {
  //     navigate("/", { replace: true });
  //   }
  // }, [user, token]);

  const onFinish = (values) => {
    if (!navigator.geolocation) {
      swal("Error", "Geolocation is not supported by your browser.", "error");
      return;
    }
  
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const location = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
  
        // Proceed with login only if location is available
        setLoading(true);
  
        let data = {
          email: values.email,
          password: values.password,
          devideId: "123456789", // consider using real device ID
          location: location, // optionally send this to backend
        };
  
        Post(USER_AUTH.login, data)
          .then((response) => {
            setLoading(false);
            if (response?.status) {
              socket.emit("setupChauffeur", response?.data?.chauffeur);
              dispatch(
                addUser({ user: response?.data?.chauffeur, token: response.data.token })
              );
              navigate("/", { replace: true });
            } else {
              swal("Oops!", response.response.data.message, "error");
            }
          })
          .catch((e) => {
            const message = e?.response?.data?.message || e.message;
            if (message) {
              swal("Oops!", message, "error");
            }
            setLoading(false);
          });
      },
      (error) => {
        swal("Location Required", "Please allow location access to proceed.", "warning");
      }
    );
  };
  

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  // const onFinish = (values) => {
  //   // Handle login logic here
  //   console.log('Received values:', values);
  // };

  return (
    <Layout
      className=""
      style={{ backgroundColor: "#fff", minHeight: "100vh" }}
    >
      <div className="">
        <Row
          style={{
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Col xs={0} md={0} lg={12}>
            <div className="auth-left-bg">
              <Link>
                <Image
                  preview={false}
                  alt={"Failed to load image"}
                  width={46}
                  height={46}
                  src={facebook}
                  style={{ maxWidth: "46px" }}
                />
              </Link>
              <Link>
                <Image
                  preview={false}
                  alt={"Failed to load image"}
                  width={46}
                  height={46}
                  src={twitter}
                  style={{ maxWidth: "46px" }}
                />
              </Link>
              <Link>
                <Image
                  preview={false}
                  alt={"Failed to load image"}
                  width={46}
                  height={46}
                  src={google}
                  style={{ maxWidth: "46px" }}
                />
              </Link>
            </div>
          </Col>
          <Col xs={23} md={23} lg={12}>
            <div className="auth-box">
              <div
                className="blur-bg-inner-card-form"
                style={{ width: "100%" }}
              >
                <div style={{ textAlign: "center" }}>
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    width={120}
                    height={110}
                    src={Logo}
                    // style={{ maxWidth: 100 }}
                  />
                </div>
                <h2 className="auth-heading">Login</h2>
                <p className="auth-p">
                  Enter your credentials to log in to the platform
                </p>
                <Form
                  layout="vertical"
                  name="basic"
                  labelCol={{
                    span: 0,
                  }}
                  wrapperCol={{
                    span: 24,
                  }}
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                >
                  <Form.Item
                    label="Email Address"
                    name="email"
                    rules={[
                      {
                        type: "email",
                        message: "Please input valid email!",
                        // warningOnly: true,
                      },
                      {
                        required: true,
                        message: "Please input your email!",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter Email Address"
                      className="web-input"
                      // style={{
                      //   borderRadius: "5px",
                      //   background: "white",
                      //   fontSize: "14px",
                      //   padding: "10px 20px",
                      // }}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                      {
                        type: "string",
                        min: 8,
                        message: "password must be atleast 8 characters!",
                      },
                    ]}
                  >
                    <Input.Password
                      size="large"
                      placeholder="Enter Password"
                      className="web-input"
                      style={{
                        borderRadius: "5px",
                        fontSize: "14px",
                        paddingRight: "10px",
                      }}
                    />
                  </Form.Item>
                  <Row>
                    <Col xs={24} md={12}>
                      <Form.Item
                        name="remember"
                        valuePropName="checked"
                        style={{ marginBottom: 0 }}
                      >
                        <Checkbox>Remember me</Checkbox>
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Button
                        type="link"
                        className="forgot-text"
                        style={{
                          float: "right",
                        }}
                        onClick={() => navigate("/forget-password-1")}
                      >
                        Forgot Password?
                      </Button>
                    </Col>
                  </Row>
                  <br />
                  <Form.Item style={{ textAlign: "center", margin: "0" }}>
                    <Button
                      type="button"
                      htmlType="submit"
                      className="web-btn"
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      {/* Login Now */}
                      {loading ? "Loading..." : "Login Now"}
                    </Button>
                  </Form.Item>
                  {/* <Row>
                    <Col lg={24} xs={24} className="signup-with-buttons">
                      <Divider>OR</Divider>
                      <div className="g-btn">
                        <a href="#_" className="signup-with-btn">
                          <Image
                            preview={false}
                            alt={"Failed to load image"}
                            src={fbicn}
                            className=""
                          />
                          Signup with Facebook
                        </a>
                        <a href="#_" className="signup-with-btn">
                          <Image
                            preview={false}
                            alt={"Failed to load image"}
                            src={gogoleicn}
                            className=""
                          />
                          Signup with Google
                        </a>
                      </div>
                    </Col>
                  </Row> */}
                  <div
                    className="already-account-text"
                    style={{ textAlign: "center" }}
                  >
                    New Member Here?
                    <span style={{cursor:"pointer"}} onClick={() => navigate("/createAccount")}>
                      Sign Up
                    </span>
                  </div>
                </Form>
                <div className="responsive-auth-social-icon">
                  <Link>
                    <Image
                      preview={false}
                      alt={"Failed to load image"}
                      width={46}
                      height={46}
                      src={facebook}
                      style={{ maxWidth: "46px" }}
                    />
                  </Link>
                  <Link>
                    <Image
                      preview={false}
                      alt={"Failed to load image"}
                      width={46}
                      height={46}
                      src={twitter}
                      style={{ maxWidth: "46px" }}
                    />
                  </Link>
                  <Link>
                    <Image
                      preview={false}
                      alt={"Failed to load image"}
                      width={46}
                      height={46}
                      src={google}
                      style={{ maxWidth: "46px" }}
                    />
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Layout>
  );
}

export default Login;
